import { AlertDialog } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./YammerFeedIdInfoDialog.module.less";

export type YammerFeedIdInfoDialogProps = {
	onClose(): void;
};

export const YammerFeedIdInfoDialog = (props: YammerFeedIdInfoDialogProps): ReactElement => {
	const { onClose } = props;

	return (
		<AlertDialog
			trackingId="find-feed-id-for-yammer-info-dialog"
			title={localize("_HowDoIFindTheFeedIdForAVivaEngageGroup")}
			onClose={onClose}
			showCloseButton
		>
			<ol>
				<li className={styles.item}>
					{localize("_HowToFindTheFeedIdForAVivaEngageGroupInformation1")}
				</li>
				<li>
					{localize("_HowToFindTheFeedIdForAVivaEngageGroupInformation2")}
				</li>
			</ol>
			<div className={styles.informationImageWrapper}>
				<div className={styles.informationImage} />
			</div>
		</AlertDialog>
	);
};

YammerFeedIdInfoDialog.displayName = "YammerFeedIdInfoDialog";
